import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/sound/recordRun.png'
import _imports_1 from '@/assets/sound/recordStop.png'
import _imports_2 from '@/assets/aivoice/ico_bofang.svg'
import _imports_3 from '@/assets/aivoice/ico_zanting.svg'
import _imports_4 from '@/assets/sound/videoImg.png'
import _imports_5 from '@/assets/sound/retreat.svg'
import _imports_6 from '@/assets/sound/play.svg'
import _imports_7 from '@/assets/sound/pause.svg'
import _imports_8 from '@/assets/sound/forward.svg'
import _imports_9 from '@/assets/sound/reset.png'
import _imports_10 from '@/assets/sound/cut.png'


const _hoisted_1 = { class: "pageRecord" }
const _hoisted_2 = { class: "pageRecordBox" }
const _hoisted_3 = { class: "aiTextBox" }
const _hoisted_4 = { class: "soundBox" }
const _hoisted_5 = { class: "timeBox" }
const _hoisted_6 = { class: "recordBox" }
const _hoisted_7 = { class: "recordBoxTime" }
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "recordBoxRun" }
const _hoisted_10 = { class: "recordBoxRunInner" }
const _hoisted_11 = { class: "recordBtnBox" }
const _hoisted_12 = {
  key: 2,
  class: "recordBtnOne"
}
const _hoisted_13 = { class: "haveFileBox" }
const _hoisted_14 = { class: "haveFileBoxInner" }
const _hoisted_15 = { class: "haveFileBoxTop" }
const _hoisted_16 = { class: "topInnerTitle" }
const _hoisted_17 = { class: "topInnerBtm" }
const _hoisted_18 = { class: "haveFileBoxBtm" }
const _hoisted_19 = { class: "btmInnerBox" }
const _hoisted_20 = { class: "btmInnerBtn" }
const _hoisted_21 = { class: "btmInnerBtnLeft" }
const _hoisted_22 = { class: "btmInnerBtnLeftName" }
const _hoisted_23 = { class: "btmInnerBtnLeftTime" }
const _hoisted_24 = { class: "btmInnerBtnCenter" }
const _hoisted_25 = { class: "btmInnerBtnRight" }
const _hoisted_26 = {
  key: 0,
  class: "btmInnerBtnRightBtn"
}
const _hoisted_27 = {
  key: 1,
  class: "btmInnerBtnRightBtn"
}
const _hoisted_28 = { class: "btmInnerWave" }

import { timeInfo, timeInfominute, timedataOther } from '@/components/public-method/time-method';
import { ref, onMounted, nextTick,getCurrentInstance} from 'vue'
import { carveTimeScale } from '../commonPage/timeLine.js'
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import Recorder from 'js-audio-recorder'
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
import {
    Close,
    CircleCloseFilled,
} from "@element-plus/icons-vue";

// 音轨引入文件
import WaveSurfer from "wavesurfer.js";
import Timeline from 'wavesurfer.js/dist/plugins/timeline.js';
import Regions, { RegionParams } from 'wavesurfer.js/dist/plugins/regions.js';

export default /*@__PURE__*/_defineComponent({
  __name: 'recordPage',
  props: {
    businessType: String,
},
  emits: ['audioChange','updataRecord','updataListening','errListen'],
  setup(__props, { expose: __expose, emit: __emit }) {

// 时间处理方法
let { proxy } = getCurrentInstance();
const token = Auth.getToken();
let wavesurfer: WaveSurfer | null = null;
let wsRegions: Regions = Regions.create() // Regions 实例
// 默认参数
const props = __props
const recorder = new Recorder({
    sampleBits: 8,                 // 采样位数，支持 8 或 16，默认是16
    sampleRate: 48000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
    numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
    // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
})
const startRecordShow = ref(true)
const lineToLeft = ref(0)
const lineIndex = ref(0)
const timeBoxLeft = ref(0)//时间轴偏移量
const audioRef = ref()
const playOnBtn = ref(false)//播放录音
const title=ref('')//上传文件名称
const upFileId=ref('')//上传文件ID
const upUrl=ref('')//上传文件url
// 上传文件

const newFile=ref()//上传文件剪切数据
const isCut=ref(false)//是否显示裁剪按钮
const cutSel=ref(false)
const duration=ref(0)//上传文件总时长
const haveFile=ref(false)//是否有上传文件
const isplay=ref(false)
const currentTime=ref(0)
// 开始录音
const startRecorder = () => {
    recorder.start().then((res) => {
        console.log(res)
        reTimeSetval = setInterval(() => {
            // 387
            reTimeStar.value += 100
            runTime.value = reTimeStar.value
            if (lineToLeft.value <= 387) {
                lineStyle.value[lineIndex.value].backgroundColor = '#17B067'
                lineToLeft.value += 6
                lineIndex.value += 1
            } else {
                // lineStyle.value.push(lineStyle.value.shift())
                lineStyle.value.push(lineStyle.value.shift())
                lineStyle.value[lineIndex.value - 1].backgroundColor = '#17B067'
                lineStyle.value[lineStyle.value.length - 1].backgroundColor = '#585F66'
                // carveTimeScale(750, 1, 60, reTimeStar.value, 2, 'time_line')
                timeBoxLeft.value -= 6
                // console.log(lineStyle.shift())
            }
        }, 100)
        startRecordShow.value = false
    }, (error) => {
        // 出错了
        ElMessage({
            type: 'error',
            message: '不存在录音设备，或者被禁用--' + error.message,
        })
        console.log(`${error.name} : ${error.message}`);
    });
}
// 结束录音
const stopRecorder = () => {
   
    if(props.businessType=='cloneVoice'&& reTimeStar.value<3000){
        return
    }
    recorder.stop()
    startRecordShow.value = true
    playOnoff.value = true
    lineStyle.value = initLine
    lineToLeft.value = 0
    lineStyle.value.forEach(item => {
        item.backgroundColor = '#585F66'
    })
    timeBoxLeft.value = 0
    lineIndex.value = 0
    reTimeStar.value = 0
    // 清除定时器
    clearInterval(reTimeSetval)
    reTimeSetval = null
    haveFile.value=true
    // this.drawRecordId && cancelAnimationFrame(this.drawRecordId);
    // this.drawRecordId = null;
    getRecorder()
}

// 获取录音文件
const titleName=ref('')
const getRecorder = () => {
    let toltime = recorder.duration;//录音总时长
    let fileSize = recorder.fileSize;//录音总大小

    //录音结束，获取取录音数据
    let PCMBlob = recorder.getPCMBlob();//获取 PCM 数据
    let wav = recorder.getWAVBlob();//获取 WAV 数据
    let time = timedataOther(Date.now())
    title.value='RECORD-' + time + '.wav'
    fileData.value = new File([wav], 'RECORD-' + time + '.wav');
    newFile.value= new File([wav], 'RECORD-' + time + '.wav');
    selAudioChange()
    wavesurfer?.empty()
    wavesurfer?.load(URL.createObjectURL(newFile.value));
    wavesurfer?.on('ready', function () {
        currentTime.value=0
        duration.value = Math.ceil(wavesurfer?.getDuration()); // 获取总时长（秒）
        console.log('Total duration:', duration);
    });
    console.log(fileData.value)
    titleName.value=fileData.value.name
    startRecordShow.value = true

    let channel = recorder.getChannelData();//获取左声道和右声道音频数据

}
// 录音播放暂停录音播放
const playRecorder = () => {

    playOnoff.value = true
    playOnBtn.value = !playOnBtn.value
    if (!playOnBtn.value) {
        // 清除定时器
        clearInterval(reTimeSetvalRun)
        reTimeSetvalRun = null
        recorder.pausePlay()


    } else {
        recorder.play()//播放
        runPlayFn()
    }

}
const runPlayFn = () => {
    reTimeSetvalRun = setInterval(() => {
        // 387
        if (reTimeStar.value < runTime.value) {
            reTimeStar.value += 100
            if (lineToLeft.value <= 387) {
                lineStyle.value[lineIndex.value].backgroundColor = '#17B067'
                lineToLeft.value += 6
                lineIndex.value += 1
            } else {
                // lineStyle.value.push(lineStyle.value.shift())
                lineStyle.value.push(lineStyle.value.shift())
                lineStyle.value[lineIndex.value - 1].backgroundColor = '#17B067'
                lineStyle.value[lineStyle.value.length - 1].backgroundColor = '#585F66'
                // carveTimeScale(750, 1, 60, reTimeStar.value, 2, 'time_line')
                timeBoxLeft.value -= 6
                // console.log(lineStyle.shift())
            }
        } else if (reTimeStar.value == runTime.value) {
            playOnBtn.value = !playOnBtn.value
            clearInterval(reTimeSetvalRun)
            reTimeSetvalRun = null
            lineStyle.value = initLine
            lineToLeft.value = 0
            lineStyle.value.forEach(item => {
                item.backgroundColor = '#585F66'
            })
            timeBoxLeft.value = 0
            lineIndex.value = 0
            reTimeStar.value = 0
        }


    }, 100)
}

const fileId=ref('')
const handleChange = () => {
    console.log(fileData.value)
    if(fileData.value==null || fileData.value==''){
        
        ElMessage({
            type: 'error',
            message: '请录制音频',
        })
        emit('errListen')
        return
    }
    if(fileId.value!=''){
        emit('updataRecord',fileId.value)
        return
    }
    let file
    if(cutSel.value){
        console.log('上传剪切文件')
        file=newFile.value
    }else{
        console.log('上传原音频')
        file=fileData.value
    }
    const formDatas = new FormData();
    formDatas.append('file',file);
    formDatas.append('businessType',props.businessType);
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            if (data.code == 200) {
                console.log(data)
                fileId.value=data.data.fileId
                emit('updataRecord',data.data.fileId)
                // upFileId.value=data.data.fileId
                // title.value=file.name
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
                emit('errListen')
            }
        }).catch(err=>{
            emit('errListen')
        })
}

nextTick(() => {
    for(let i=0;i<100;i++){
        carveTimeScale(1500, 1, 60, 25000*i, 2, 'time_line'+i)
    }   
})
// 
const lineStyle = ref([])
const initLine = []
const linfHeight = [10, 30, 80, 160, 80, 40, 100, 60, 80, 60, 30, 10, 10, 40]
for (let i = 0; i < 135; i++) {
    const obj = {
        'height': linfHeight[i % 14] + 'px',
        'backgroundColor': '#585F66'
    }
    initLine.push(obj)
    lineStyle.value.push(obj)
}

// 录音定时器
let reTimeSetval = null
const reTimeStar = ref(0)
// 录音组件
const audioBlobUrl = ref(null);
const fileData = ref()
const playOnoff = ref(false)
// 播放录音
let reTimeSetvalRun = null
// 录音播放进度
const runTime = ref(0)
// 录音播放时间
const updateCurrentTime = (e: any) => {
    // console.log(e.target.currentTime)
    // 音频播放完后暂停
    if (e.target.currentTime >= audioRef.value.duration) {
        clearInterval(reTimeSetvalRun)
        reTimeSetvalRun = null
        playOnBtn.value = false
        lineStyle.value = initLine
        lineToLeft.value = 0
        lineStyle.value.forEach(item => {
            item.backgroundColor = '#fff'
        })
        timeBoxLeft.value = 0
        runTime.value = 0
        lineIndex.value = 0
        reTimeStar.value = 0
    }
}
// 关闭页面  defineEmits
const emit = __emit
// 重新录音
const changeRecord = () => {
    console.log('重新录音')
    // startRecordShow&&!playOnoff
    fileId.value=''
    titleName.value=''
    startRecordShow.value = true
    playOnoff.value = false
    lineStyle.value = initLine
    lineToLeft.value = 0
    lineStyle.value.forEach(item => {
        item.backgroundColor = '#fff'
    })
    timeBoxLeft.value = 0
    runTime.value = 0
    lineIndex.value = 0
    reTimeStar.value = 0


}
const updataRecording=()=>{
    handleChange()
}
const updataRecordingListening=()=>{
    if(fileData.value==undefined || fileData.value=='' || fileData.value==null){
        ElMessage({
            type: 'error',
            message: '请录制音频',
        })
        emit('errListen')
        return
    }
    let file
    if(cutSel.value){
        console.log('上传剪切文件')
        file=newFile.value
    }else{
        console.log('上传原音频')
        file=fileData.value
    }
    const formDatas = new FormData();
    formDatas.append('file',file);
    formDatas.append('businessType',props.businessType);
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                console.log(data)
                emit('updataListening',data.data.url)
                // upFileId.value=data.data.fileId
                // title.value=file.name
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
                emit('errListen')
            }
            

        })
}
// 重置音轨
const resetFun=()=>{
    if(fileData.value==null || fileData.value==''){
        return
    }
    isCut.value=false
    cutSel.value=false
    wavesurfer?.load(URL.createObjectURL(fileData.value));
    wavesurfer?.seekTo(0, 1)
    wsRegions?.clearRegions()
}
// 提交上传文件
const submiltFile=()=>{
    console.log('提交上传文件')
    if(fileData.value==null || fileData.value==''){
        ElMessage({
            type: 'error',
            message: '请上传音频',
        })
        emit('errListen')
        return
    }
    let file
    if(isCut.value){
        console.log('上传剪切文件')
        file=newFile.value
    }else{
        console.log('上传原音频')
        file=fileData.value
    }
    const formDatas = new FormData();
    formDatas.append('file',file);
    formDatas.append('businessType','cloneVoice');
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                console.log(data)
                if(props.isSave){
                    emit('saveFun',[data.data.fileId,data.data.url])
                }else{
                    emit('listenFun',[data.data.fileId,data.data.url])
                }
                
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            

        })
}
// 加载音轨
onMounted(()=>{
    initWave()
})
const topTimeline = Timeline.create({
  container: '#timeline',
  height: 20,
  insertPosition: 'beforebegin',
  style: {
    fontSize: '10px',
    color: '#848485',
    background:'#1B1D1F'
  },
})

const audioUrl=ref('https://wavesurfer.xyz/wavesurfer-code/examples/audio/audio.wav')
const initWave=()=>{
    console.log('加载音轨')
    wavesurfer = WaveSurfer.create({
            container: document.querySelector('#wavesurferId'),
            waveColor: 'rgba(255, 255, 255, 0.4)',
            progressColor: 'rgba(255, 255, 255, 0.5)',
            cursorColor: 'rgba(255, 255, 255, 1)',
            height: 120,
            cursorWidth: 2,
            // url: audioUrl.value,
            url:proxy.getimgUrlVoice + '/' + audioUrl.value,
            plugins: [topTimeline,wsRegions],
            dragToSeek: true,
            
        });
        wavesurfer?.on('timeupdate', (Time) => {
            // console.log(currentTime)
            currentTime.value=Math.ceil(Time)
        }) 
        wavesurfer?.on('finish', function() {
            console.log('播放完成！');
            isplay.value=false
           
        });       
}
// 裁剪
const startTimeInput=ref(0)
const endTimeInput=ref(0)
let cutAudioBlob = null;
let audioBlob = null;
let activeRegion = null
const trimFun=()=>{
    startTimeInput.value=0
    isCut.value=true
    endTimeInput.value=(duration.value/4).toFixed(0)
        wsRegions.addRegion({
            start: startTimeInput.value,
            end: endTimeInput.value,
            content: (endTimeInput.value-startTimeInput.value).toFixed(0)+'S',
            color: 'rgba(76,114,68,0.2)',
            drag: true,
            resize: true,
        })

        wsRegions.on('region-updated', (region) => {
            console.log('Updated region', region)
            startTimeInput.value = region.start.toFixed(0);
            endTimeInput.value = region.end.toFixed(0);
            let str=region.element.querySelector("[part='region-content']")
            str.innerHTML=(endTimeInput.value-startTimeInput.value).toFixed(0)+'S'
        })

        wsRegions.on('region-in', (region) => {
            console.log('region-in', region)
            activeRegion = region
        })
        wsRegions.on('region-out', (region) => {
            console.log('region-out', region)
            if (activeRegion === region) {
                if (isCut.value) {
                    region.play()
                } else {
                    activeRegion = null
                }
            }
        })
}
// 确认裁剪
const  trimOk=()=> {
    const startTime = parseFloat(startTimeInput.value);
    const endTime = parseFloat(endTimeInput.value);
    
    if (isNaN(startTime) || isNaN(endTime) || startTime >= endTime) {
        alert('请输入有效的开始和结束时间');
        return;
    }
    
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const reader = new FileReader();
    
    reader.onload = async function(event) {
        try {
            const audioData = event.target.result;
            const audioBuffer = await audioContext.decodeAudioData(audioData);
            
            // 创建新的 AudioBuffer 用于存储剪切后的音频
            const channels = audioBuffer.numberOfChannels;
            const sampleRate = audioBuffer.sampleRate;
            const startOffset = Math.floor(startTime * sampleRate);
            const endOffset = Math.floor(endTime * sampleRate);
            const frameCount = endOffset - startOffset;
            
            const newAudioBuffer = new AudioBuffer({
                length: frameCount,
                numberOfChannels: channels,
                sampleRate: sampleRate
            });
            
            // 复制音频数据
            for (let i = 0; i < channels; i++) {
                const channelData = audioBuffer.getChannelData(i);
                const newChannelData = newAudioBuffer.getChannelData(i);
                for (let j = 0; j < frameCount; j++) {
                    newChannelData[j] = channelData[startOffset + j];
                }
            }
            
            // 导出为 WAV 文件
            const blob = await bufferToWave(newAudioBuffer, frameCount);
            cutAudioBlob = blob;
            newFile.value=new File([blob], title.value)
            selAudioChange()
            // 创建预览
            const audioUrl = URL.createObjectURL(blob);
            cutSel.value=true
           
            wavesurfer?.load(audioUrl);
            // initPreviewWavesurfer(audioUrl);
            
            // 显示预览区域
            // previewSection.style.display = 'block';
            
        } catch (error) {
            console.error('音频剪切错误:', error);
            alert('音频剪切失败，请重试');
        }
    };
    

    reader.readAsArrayBuffer(fileData.value);
    // 重置音轨
    wavesurfer?.seekTo(0, 1)
    wsRegions?.clearRegions()
    isCut.value=false
}
// 取消
const trimNo=()=>{
    isCut.value=false
    newFile.value=fileData.value
    wsRegions?.clearRegions()
}
// 清除音频
const clearFile=()=>{
    haveFile.value=false
    fileData.value=null
    title.value=''
    playOnoff.value=false
    toPause()
    changeRecord()
    selAudioChange()
}
// 将 AudioBuffer 转换为 WAV 格式的 Blob
async function bufferToWave(buffer, len) {
    const numOfChan = buffer.numberOfChannels;
    const length = len * numOfChan * 2 + 44;
    const bufferArray = new ArrayBuffer(length);
    const view = new DataView(bufferArray);
    const channels = [];
    
    let sampleRate = buffer.sampleRate;
    let bytesPerSample = 2;
    let blockAlign = numOfChan * bytesPerSample;
    
    // WAV 头部
    writeString(view, 0, 'RIFF');
    view.setUint32(4, length - 8, true);
    writeString(view, 8, 'WAVE');
    writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, numOfChan, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * blockAlign, true);
    view.setUint16(32, blockAlign, true);
    view.setUint16(34, bytesPerSample * 8, true);
    writeString(view, 36, 'data');
    view.setUint32(40, length - 44, true);
    
    // 写入音频数据
    for (let i = 0; i < numOfChan; i++) {
        channels.push(buffer.getChannelData(i));
    }
    
    let offset = 44;
    let pos = 0;
    
    while (pos < len) {
        for (let i = 0; i < numOfChan; i++) {
            let sample = Math.max(-1, Math.min(1, channels[i][pos]));
            sample = (0 < sample) ? sample * 32767 : sample * 32768;
            view.setInt16(offset, sample, true);
            offset += 2;
        }
        pos++;
    }
    
    return new Blob([bufferArray], { type: 'audio/wav' });
}
// 写入字符串到 DataView
const writeString=(view, offset, string) =>{
    for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
    }
}
// 播放
const toPlay=()=>{
    wavesurfer?.play()
    isplay.value=true
}
const toPause=()=>{
    wavesurfer?.pause()
    isplay.value=false
}
// 快进，后退
const skipFor=()=>{
    wavesurfer?.skip(6)
}
const skipBack=()=>{
    wavesurfer?.skip(-6)
}
// 判断上传音频是否改变
const selAudioChange=()=>{
    emit('audioChange')
}
__expose({
    updataRecording,
    updataRecordingListening,
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(timeInfominute)(reTimeStar.value)), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "recordBoxTimeBox",
                style: _normalizeStyle({ 'left': timeBoxLeft.value + 'px' })
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(100, (item, index) => {
                  return _createElementVNode("canvas", {
                    id: 'time_line'+index,
                    width: "1500",
                    height: "30",
                    key: index
                  }, null, 8, _hoisted_8)
                }), 64))
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lineStyle.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "recordBoxRunInnerOne",
                    style: _normalizeStyle({ 'height': item.height, 'backgroundColor': item.backgroundColor })
                  }, null, 4))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: "timeLine",
              style: _normalizeStyle({ 'left': lineToLeft.value - 4 + 'px' })
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "timeBlock" }, [
                _createElementVNode("div", { class: "square" }),
                _createElementVNode("div", { class: "arrow" }),
                _createElementVNode("div", { class: "line" })
              ], -1)
            ]), 4)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (startRecordShow.value && !playOnoff.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "recordBtnOne",
                  onClick: startRecorder
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "recordBtnOneBtn"
                  }, null, -1),
                  _createElementVNode("span", null, "开始录音", -1)
                ])))
              : _createCommentVNode("", true),
            (!startRecordShow.value && !playOnoff.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "recordBtnOne",
                  onClick: stopRecorder
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "recordBtnOneBtn"
                  }, null, -1),
                  _createElementVNode("span", null, "结束录音", -1)
                ])))
              : _createCommentVNode("", true),
            (playOnoff.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (!playOnBtn.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_2,
                        onClick: playRecorder
                      }))
                    : _createCommentVNode("", true),
                  (playOnBtn.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_3,
                        onClick: playRecorder
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !haveFile.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_4 }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(title.value), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", {
              onClick: _withModifiers(clearFile, ["stop"])
            }, "重新录音")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(title.value), 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", null, _toDisplayString(_unref(timeInfominute)(currentTime.value*1000)), 1),
                _cache[4] || (_cache[4] = _createTextVNode(" / ")),
                _createElementVNode("span", null, _toDisplayString(_unref(timeInfominute)(duration.value*1000)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("img", {
                src: _imports_5,
                onClick: _withModifiers(skipBack, ["stop"])
              }),
              _withDirectives(_createElementVNode("img", {
                src: _imports_6,
                onClick: _withModifiers(toPlay, ["stop"])
              }, null, 512), [
                [_vShow, !isplay.value]
              ]),
              _withDirectives(_createElementVNode("img", {
                src: _imports_7,
                onClick: _withModifiers(toPause, ["stop"])
              }, null, 512), [
                [_vShow, isplay.value]
              ]),
              _createElementVNode("img", {
                src: _imports_8,
                onClick: _withModifiers(skipFor, ["stop"])
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              (!isCut.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("img", {
                      src: _imports_9,
                      onClick: _withModifiers(resetFun, ["stop"])
                    }),
                    _createElementVNode("img", {
                      src: _imports_10,
                      onClick: _withModifiers(trimFun, ["stop"])
                    })
                  ]))
                : _createCommentVNode("", true),
              (isCut.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("span", {
                      onClick: _withModifiers(trimOk, ["stop"]),
                      class: "trimBtnYes"
                    }, "修剪"),
                    _createElementVNode("span", {
                      class: "trimBtnNo",
                      onClick: _withModifiers(trimNo, ["stop"])
                    }, "取消")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", {
              class: "closeWave",
              onClick: _withModifiers(clearFile, ["stop"])
            }, [
              _createVNode(_component_el_icon, { color: "#969FA1" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Close))
                ]),
                _: 1
              })
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", {
              id: "timeline",
              class: "wavesurfertimeInner"
            }, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("div", {
              id: "wavesurferId",
              class: "wavesurferInner"
            }, null, -1))
          ])
        ])
      ])
    ], 512), [
      [_vShow, haveFile.value]
    ])
  ]))
}
}

})